export * from '@primeuix/themes/nora/editor';
export { default } from '@primeuix/themes/nora/editor';
